import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Card,
  Button,
  Alert,
  Link
} from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import { SendingReportAPI } from "API/SendingReportAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse } from "helpers/notification";
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import { customSelectStyles } from "style";
import moment from 'moment';
import { alertWarningText } from "helpers/notification";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { endDateControl } from "helpers/helper";
import gregorian_tr from "helpers/gregorian_tr";
import weekends from "react-multi-date-picker/plugins/highlight_weekends";

function SendingReport() {

  // consts
  const [userEuIdData, setUserEuIdData] = useState([]);
  const [userEuIdSelectedOption, setUserEuIdSelectedOption] = useState({
    value: "",
    label: "",
  });
  const [userEuId, setUserEuId] = useState("");

  const [flag, setFlag] = useState(false);

  const [senderData, setSenderData] = useState([]);
  const [senderSelectedOption, setSenderSelectedOption] = useState({
    value: "",
    label: "",
  });
  const [sender, setSender] = useState("");

  const [msgSpecialId, setMsgSpecialId] = useState("");

  let date = new Date();
  const [startDate, setStartDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 00:00:00");
  const [endDate, setEndDate] = useState(date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + ("0" + date.getDate()).slice(-2) + " 23:59:59");

  const maxDate = new Date();
  const minDate = new Date();
  minDate.setMonth(minDate.getMonth() - 3);

  const validateDateRange = (startDate, endDate) => {
    const minDateISO = moment(minDate).format('YYYY-MM-DD');
    return !(moment(startDate).format('YYYY-MM-DD') < minDateISO) && !(moment(endDate).format('YYYY-MM-DD') < minDateISO);
  }

  const [queryId, setQueryId] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");

  const [queryName, setQueryName] = useState("");

  const navigate = useNavigate();

  var groupId = useSelector(state => state.common.groupId);
  var rightFormat = useSelector(state => state.common.rightFormat);
  var userName = useSelector(state => state.common.userName);

  // functions

  const getUserGroupRelatedLoginName = async () => {
    if (Number(groupId) === -1) {
      const response = await SendingReportAPI.GetUserEuIdByLoginName(userName);

      if (checkResponse(response, null, "Kullanıcı bilgisi getirme işlemi başarısız oldu.Lütfen Tekrar deneyin.")
      ) {
        const currentUser = response?.data?.resultObject?.[0];

        if (currentUser) {
          const option = {
            value: currentUser.userEuId,
            label: currentUser.loginName
          };

          setUserEuIdData([option]);
          setUserEuIdSelectedOption(option);
          setUserEuId(currentUser.userEuId);
        }
      }

      return;
    }
    const getUserGroupRelatedLoginNameResponse = await SendingReportAPI.GetUserGroupRelatedLoginName(groupId);

    if (checkResponse(getUserGroupRelatedLoginNameResponse, null, "Kullanıcıları getirme işlemi başarısız oldu.Lütfen Tekrar deneyin.")
    ) {
      let array = [];
      getUserGroupRelatedLoginNameResponse.data.resultObject.map(data => {
        array.push({ value: data.userEuId, label: data.loginName });
      });

      setUserEuIdData(array);
    }
  };

  const getSenderListOfSelectedLoginName = async e => {

    const getSenderListOfSelectedLoginNameResponse = await SendingReportAPI.GetSenderListOfSelectedLoginName(
      userEuIdSelectedOption.label
    );
    if (
      checkResponse(
        getSenderListOfSelectedLoginNameResponse,
        null,
        "Mesaj Başlıkları getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      let array = [];
      array.push({ value: "0", label: "Hepsi" });
      getSenderListOfSelectedLoginNameResponse.data.resultObject.map(data => {
        array.push({ value: data.smsHeader, label: data.smsHeader });
      });

      setSenderData(array);
      setSenderSelectedOption({
        value: "0",
        label: "Hepsi",
      });
      setSender("0");
    }
  };

  const insertQuery = async e => {

    setShowAlert(false);

    if (userEuId == "") {
      alertWarningText("Lütfen en az bir kullanıcı seçiniz.");
      return;
    }

    if (!validateDateRange(startDate, endDate)) {
      alertWarningText("Lütfen son üç ay içinde geçerli bir tarih aralığı seçiniz.");
      return;
    }

    if (startDate > endDate) {
      alertWarningText("Lütfen geçerli bir tarih aralığı seçiniz.Bitiş tarihi başlangıç tarihinden küçük olamaz");
      return;
    }

    let parameters = {
      userEuId: userEuId,
      sender: sender === 0 ? null : sender,
      msgSpecialId: msgSpecialId,
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      endDate: moment(endDateControl(endDate)).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      rightFormat: rightFormat
    }

    const isExistQueryResponse = await QueryAPI.IsExistQuery("sendingreport", userName, parameters);
    if (isExistQueryResponse.data.resultObject.isExist) {
      alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
      return;
    }

    const insertQueryResponse = await QueryAPI.InsertQuery(
      userName,
      0,
      "sendingreport",
      queryName,
      new Date(),
      parameters
    );
    if (
      checkResponse(
        insertQueryResponse,
        null,
        "Gönderim Raporu getirme işlemi başarısız oldu.Lütfen Tekrar deneyin."
      )
    ) {
      if (insertQueryResponse.data.resultObject !== "") {
        setQueryId(insertQueryResponse.data.resultObject);
        setShowAlert(true);
        setAlertType("success");
      }
    }
  }

  useEffect(() => {

    if (userEuId !== "" && sender !== "" && flag) {
      // filterOnClick();
      // setFlag(false);
    }
  }, [flag, userEuId, sender, startDate, endDate]);

  useEffect(() => {
    getUserGroupRelatedLoginName();
  }, []);

  useEffect(() => {
    if (userEuIdData.length > 0) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      if (params.size > 0) {
        setUserEuId(params.get("userEuId"));
        setUserEuIdSelectedOption(userEuIdData.find(u => u.value === params.get("userEuId")));
      }
    }
  }, [userEuIdData]);

  useEffect(() => {
    if (senderData.length > 0) {
      let search = window.location.search;
      let params = new URLSearchParams(search);
      if (params.size > 0) {
        setSender(params.get("sender"));
        setSenderSelectedOption(senderData.find(s => s.label === params.get("sender")));
        setStartDate(params.get("startDate"));
        setEndDate(params.get("endDate"));
        setFlag(true);
      }
    }
  }, [senderData]);

  useEffect(() => {
    if (userEuIdSelectedOption !== undefined)
      getSenderListOfSelectedLoginName();
  }, [userEuIdSelectedOption]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={1}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant='gradient'
                bgColor='info'
                borderRadius='lg'
                coloredShadow='info'
              >
                <MDTypography variant='h6' color='white'>
                  Gönderim Raporu Filtresi
                </MDTypography>
                <MDTypography style={{ fontSize: "13px" }} color='white'>
                  Kullanıcı seçerek yapılan gönderimlerin özet rakamlarını görebilirsiniz.
                  Gönderim raporunu ekranda görüntüleyebileceğiniz gibi dosya olarak da alabilirsiniz.
                </MDTypography>
              </MDBox>

              <MDBox pt={2} pb={2} px={2}>
                <Grid container spacing={4}>

                  <Grid item xs={12} md={12} lg={6}>

                    <Grid container spacing={0} sx={style.gridStyle}>
                      <Grid item xs={4} md={4} lg={4} >
                        <h6>Kullanıcı Adı : </h6>
                      </Grid>
                      <Grid item xs={8} md={8} lg={8} border={'1px solid #ccc'} borderRadius={'6px'}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={customSelectStyles}
                          value={userEuIdSelectedOption}
                          options={userEuIdData}
                          onChange={option => {
                            setUserEuIdSelectedOption(option ? option : {});
                            setUserEuId(option ? option.value : "");
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={0} sx={style.gridStyle}>
                      <Grid item xs={4} md={4} lg={4}>
                        <h6>Mesaj Başlığı : </h6>
                      </Grid>
                      <Grid item xs={8} md={8} lg={8} border={'1px solid #ccc'} borderRadius={'6px'}>
                        <Select
                          menuPortalTarget={document.body}
                          styles={customSelectStyles}
                          value={senderSelectedOption}
                          options={senderData}
                          onChange={option => {
                            setSenderSelectedOption(option ? option : {});
                            setSender(option ? option.value : "");
                          }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={0} sx={style.gridStyle}>
                      <Grid item xs={4} md={4} lg={4}>
                        <h6>Sorgu Adı : </h6>
                      </Grid>
                      <Grid item xs={8} md={8} lg={8}>
                        <MDInput
                          style={{
                            ...style.inputStyle,
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                          }}
                          type='text'
                          value={queryName}
                          onChange={e => setQueryName(e.target.value)}
                          inputProps={{ maxLength: 100 }}
                        />
                      </Grid>
                    </Grid>

                  </Grid>

                  <Grid item xs={12} md={12} lg={6}>

                    <Grid container spacing={0} sx={style.gridStyle}>
                      <Grid item xs={4} md={4} lg={4}>
                        <h6>Mesaj Konusu : </h6>
                      </Grid>
                      <Grid item xs={8} md={8} lg={8}>
                        <MDInput
                          style={{
                            ...style.inputStyle,
                            border: '1px solid #ccc',
                            borderRadius: '6px',
                          }}
                          type='text'
                          value={msgSpecialId}
                          onChange={e => setMsgSpecialId(e.target.value)}
                          inputProps={{ maxLength: 50 }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container spacing={0} sx={style.gridStyle}>
                      <Grid item xs={4} md={4} lg={4}>
                        <h6>Tarih : </h6>
                      </Grid>
                      <Grid item xs={4} md={4} lg={4}>
                        <DatePicker
                          plugins={[weekends()]}
                          format="YYYY-MM-DD"
                          value={startDate}
                          minDate={minDate}
                          maxDate={maxDate}
                          locale={gregorian_tr}
                          style={{
                            ...style.datepickerStyle,
                            border: '2px solid #ccc',
                            borderRadius: '6px',
                          }}
                          onChange={value => setStartDate(value.format("YYYY-MM-DD HH:mm"))}
                          slotProps={{ textField: { fullWidth: true } }}
                        />
                      </Grid>
                      <Grid item xs={4} md={4} lg={4}>
                        <DatePicker
                          plugins={[weekends()]}
                          format="YYYY-MM-DD"
                          value={endDate}
                          minDate={minDate}
                          maxDate={maxDate}
                          locale={gregorian_tr}
                          style={{
                            ...style.datepickerStyle,
                            border: '2px solid #ccc',
                            borderRadius: '6px',
                          }}
                          onChange={value => setEndDate(`${value.format("YYYY-MM-DD")} 23:59:59`)}
                        />
                      </Grid>
                    </Grid>

                  </Grid>

                  <Grid style={{ fontSize: "12px" }} item xs={12} md={12} lg={12}>
                    Bu menüden sadece Bulk SMS servisinden (BulkAPI ve ARAYÜZ) yapılan gönderimlerinizin raporu alınabilmektedir.
                    <span style={{ color: "red", fontWeight: "bold", fontStyle: "italic", textDecorationLine: 'underline' }}>(Fast SMS servisine ait raporlarınız için "Firma Raporu" menüsünü kullanabilirsiniz.)</span>
                  </Grid>

                  <Grid container spacing={0} sx={style.gridStyle}>
                    <Grid item xs={12} md={12} lg={12}>

                      <Button style={style.buttonStyle} onClick={insertQuery}>
                        Sorgu Talebi Oluştur
                      </Button>

                    </Grid>
                  </Grid>

                  {showAlert ? <Grid container spacing={0} sx={style.gridStyle}>
                    <Grid item xs={12} md={12} lg={12}>

                      <Alert
                        severity="success"
                        sx={{
                          marginLeft: "30px",
                          backgroundColor: "#d8f4da",
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "4px"
                        }}
                      >
                        Sorgunuz <b>{queryId}</b> id si ile işleme alınmıştır.
                        <b>Sorgular</b> ekranından görüntüleyebilirsiniz.
                        <Button
                          size="small"
                          sx={{
                            marginLeft: "10px",
                            marginRight: "6px",
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: "12px",
                            color: "#000",
                            backgroundColor: "#bfe8c6",
                            border: "1px solid #6fbf7f",
                            borderRadius: "8px",
                            padding: "2px 10px",
                            minHeight: "26px",

                            "&:hover": {
                              backgroundColor: "#aee0b7"
                            }
                          }}
                          onClick={() => navigate("/Sorgular", { state: { queryId } })}
                        >
                          Sorguyu Aç
                        </Button>
                      </Alert>



                    </Grid>
                  </Grid> : ""}

                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

    </DashboardLayout>
  );
}

export default SendingReport;
